import {action, computed, makeObservable, observable, toJS} from 'mobx'

import {SubscriptionService as Service} from 'rest/services/SubscriptionService'
import {Stores} from './index'
import {SubscriptionDto} from 'rest/models/SubscriptionDto'

export class SubscriptionStore {
  stores: Stores
  _subscription: SubscriptionDto[]

  constructor(stores: Stores) {
    this.stores = stores
    makeObservable(this, {
      _subscription: observable,
      subscription: computed,
      getSubscription: action,
    })
  }

  get subscription() {
    return (toJS(this._subscription) || [])[0]
  }

  getSubscription = async (): Promise<any> => {
    try {
      const res = await Service.getApiSubscriptionGetList()
      this._subscription = res.data
    } catch (err) {
      this.stores.ErrorStore.handle(err)
    }
  }
}
